angular.module('admin.directives')

  .directive('agentSendWelcomeAction', ['AgentService', 'PageNotificationService', function(AgentService, PageNotificationService){
    return {
      restrict: 'E',
      controllerAs: 'sendWelcomeCtrl',
      bindToController: {
        agentId: '@'
      },
      scope: {},
      templateUrl: '/admin/templates/partials/agent-send-welcome-action.html',

      controller: function(){
        var ctrl = this;

        ctrl.sendWelcome = function(){
          ctrl.loading = true;

          return AgentService.sendWelcome(ctrl.agentId)
            .then(success)
            .catch(error);
        };

        function success(){
          ctrl.loading = false;
        }

        function error(err){
          ctrl.loading = false;
          PageNotificationService.info('There was an error sending the welcome email.');
        }
      }
    }

  }]);
